import { render, staticRenderFns } from "./PayerBalanceHistory.vue?vue&type=template&id=4d95c451&scoped=true"
import script from "./PayerBalanceHistory.vue?vue&type=script&lang=js"
export * from "./PayerBalanceHistory.vue?vue&type=script&lang=js"
import style0 from "./PayerBalanceHistory.vue?vue&type=style&index=0&id=4d95c451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95c451",
  null
  
)

export default component.exports